import { Button } from '@tmov/design-system';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin: 24px 0;

  overflow: visible;
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.12);
  border-radius: 8px;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TabelaHeader = styled.div`
  width: 100%;
  padding: 12px 16px;

  background-color: #f4f6f8;

  display: flex;
  justify-content: space-between;
  align-items: center;

  p {
    margin: 0;
    font-weight: 700;
    font-size: 14px;
  }
`;

export const Tabela = styled.table`
  width: 100%;

  tr {
    padding: 14px 20px;

    box-shadow: inset 0px -1px 0px rgba(145, 158, 171, 0.24);

    display: grid;
    grid-template-columns: 15% 20% 10% 10% 24% 12% 5%;
  }

  th,
  td {
    display: flex;
  }

  svg {
    font-size: 22px;
  }

  .ant-tag {
    margin: 0;
  }
`;

export const SubTitle = styled.span`
  display: block;
  white-space: nowrap;
  width: 17vw;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const IconButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
`;

export const FiltroData = styled(Button)`
  font-family: 'Inter' !important;
  width: 88px;
  height: 36px;
`;
